export default __webpack_public_path__ + "static/slider3-6efe973328896ce452800ec8345d3a1e.jpg";